import { Link } from 'react-router-dom';
import { getPopularManga } from '@/mocks/manga';

export default function HotRecommend() {
  const popular = getPopularManga(3);
  const [main, ...rest] = popular;

  if (!main) return null;

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <p className="text-foreground-500 text-sm mb-2">精选推荐</p>
          <h2 className="text-3xl md:text-5xl font-heading font-black text-foreground-950 leading-tight">
            热门漫画
            <br />
            大家都在看
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Link
            to={`/manga/${main.slug}`}
            className="group relative rounded-2xl overflow-hidden cursor-pointer aspect-[4/3] lg:aspect-auto"
          >
            <img
              src={main.cover}
              alt={main.title}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute top-4 left-4 flex items-center gap-2">
              {main.tags.slice(0, 3).map((tag) => (
                <span key={tag} className="bg-white/20 backdrop-blur-md text-white text-xs px-3 py-1 rounded-full">
                  {tag}
                </span>
              ))}
            </div>
            <div className="absolute bottom-6 left-6 right-6">
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-2">{main.title}</h3>
              <p className="text-white/70 text-sm line-clamp-2">{main.description}</p>
              <div className="flex items-center gap-4 mt-3 text-white/60 text-xs">
                <span><i className="ri-eye-line mr-1"></i>{(main.views / 10000).toFixed(0)}万</span>
                <span><i className="ri-star-fill text-primary-400 mr-1"></i>{main.rating}</span>
                <span className="bg-accent-500 text-white px-2 py-0.5 rounded text-xs">{main.updateStatus}</span>
              </div>
            </div>
          </Link>

          <div className="flex flex-col gap-6">
            {rest.map((manga) => (
              <Link
                key={manga.id}
                to={`/manga/${manga.slug}`}
                className="group bg-background-100 rounded-2xl p-4 md:p-5 flex gap-4 cursor-pointer hover:bg-background-200/70 transition-colors"
              >
                <div className="w-24 md:w-32 flex-shrink-0 rounded-xl overflow-hidden">
                  <img
                    src={manga.cover}
                    alt={manga.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="bg-accent-100 text-accent-700 text-xs px-2 py-0.5 rounded-full">{manga.category}</span>
                      <span className="text-foreground-400 text-xs">{manga.author}</span>
                    </div>
                    <h3 className="text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                      {manga.title}
                    </h3>
                    <p className="text-foreground-500 text-sm mt-1 line-clamp-2">{manga.description}</p>
                  </div>
                  <div className="flex items-center gap-3 mt-2 text-foreground-400 text-xs">
                    <span>更新至 {manga.latestChapter}</span>
                    <span className="flex items-center"><i className="ri-star-fill text-primary-500 mr-1"></i>{manga.rating}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}